import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  ShoppingCart, 
  ShoppingBag,
  Users, 
  Leaf, 
  Home,
  Tags,
  Tag,
  FileText,
  BarChart3
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navigation = [
  { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { name: 'Products', href: '/admin/products', icon: Package },
  { name: 'Orders', href: '/admin/orders', icon: ShoppingCart },
  { name: 'Abandoned Carts', href: '/admin/abandoned-carts', icon: ShoppingBag },
  { name: 'Promo Codes', href: '/admin/promo-codes', icon: Tag },
  { name: 'Users', href: '/admin/users', icon: Users },
  { name: 'Plant Care', href: '/admin/plant-care', icon: Leaf },
  { name: 'Categories', href: '/admin/categories', icon: Tags },
  { name: 'Homepage', href: '/admin/homepage', icon: Home },
  { name: 'Static Pages', href: '/admin/static-pages', icon: FileText },
  { name: 'Analytics', href: '/admin/analytics', icon: BarChart3 },
];

const Sidebar = () => {
  const location = useLocation();

  return (
    <div className="bg-gray-900 text-white w-64 min-h-screen p-4">
      <div className="mb-8">
        <h2 className="text-xl font-bold">Admin Panel</h2>
      </div>
      <nav className="space-y-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors',
                isActive
                  ? 'bg-gray-800 text-white'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white'
              )}
            >
              <item.icon className="mr-3 h-5 w-5" />
              {item.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
